import React, { useState, useEffect } from "react";
import { Link } from "gatsby";

import SiteContext from "gatsby-theme-docs-engine/src/context/site";

import "./styles.sass";

import { DengineContent } from "gatsby-theme-docs-engine/src/types";

const defaultStyling = {
  backgroundImage:
    "linear-gradient(90deg,#3f8bfd,#483bec),linear-gradient(90deg,#483bec,#483bec)",
  color: "white"
};

const Footer: React.SFC<{}> = () => {
  const [brandmarkHover, setBrandmarkHover] = useState(false);

  const handleMouseEnter = () => {
    if (brandmarkHover !== true) {
      setBrandmarkHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (brandmarkHover !== false) {
      setBrandmarkHover(false);
    }
  };

  return (
    <SiteContext.Consumer>
      {({ footer = {} }: DengineContent) => {
        const footerStyling = Object.assign(
          {},
          defaultStyling,
          footer.style || {}
        );

        return (
          <footer style={footerStyling} className="footer">
            <div className="container">
              <a className="brandmark" href="https://ironstar.io">
                <div
                  className={`left${brandmarkHover === true ? " hovered" : ""}`}
                >
                  Tokaido by
                </div>
                <div
                  className="logo"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <svg
                    width="45"
                    height="45"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill="currentColor"
                      d="M13.928.1A24.037 24.037 0 0 0 .185 13.715c-.236.595-.072 1.275.383 1.725l.305.3a9.414 9.414 0 0 1-.064 13.314l-.307.299A1.642 1.642 0 0 0 0 30.5v.042c.002.179.035.358.1.531a24.048 24.048 0 0 0 13.613 13.743c.595.235 1.276.07 1.726-.384l.3-.305c3.694-3.659 9.656-3.631 13.315.064l.298.307c.306.317.723.496 1.148.502h.04c.18-.002.359-.035.533-.1a24.042 24.042 0 0 0 13.744-13.614c.234-.595.07-1.275-.385-1.725l-.304-.3a9.416 9.416 0 0 1 .062-13.315l.308-.297c.46-.445.63-1.124.401-1.721A24.04 24.04 0 0 0 31.286.184a1.61 1.61 0 0 0-1.724.385l-.3.304A9.415 9.415 0 0 1 15.945.809l-.297-.306A1.64 1.64 0 0 0 14.477 0c-.185 0-.37.033-.549.1m8.527 32.017c-5.313-.024-9.598-4.351-9.573-9.662.025-5.313 4.352-9.598 9.664-9.572 5.312.024 9.597 4.351 9.572 9.662a9.616 9.616 0 0 1-9.615 9.572h-.048"
                      id="a"
                    />
                  </svg>
                </div>
                <div
                  className={`right${
                    brandmarkHover === true ? " hovered" : ""
                  }`}
                >
                  <svg viewBox="0 0 198 20">
                    <path
                      fill="white"
                      d="M0 19.696V.304h4.092v19.392zM28.193 19.696l-3.823-6.221h-3.293v6.221h-4.118V.304h8.019c.104-.005.225-.007.348-.007 1.879 0 3.61.637 4.988 1.707l-.018-.014c1.29 1.044 2.108 2.627 2.108 4.401 0 .087-.002.174-.006.26v-.012c.001.036.001.078.001.12 0 2.631-1.548 4.899-3.784 5.945l-.04.017 4.292 6.994zM21.077 4.057v5.621h3.18c2.685 0 4.04-.947 4.04-2.85s-1.268-2.772-4.04-2.772zM46.203 2.85c1.747-1.762 4.168-2.853 6.843-2.853.083 0 .167.001.25.003h-.012c.073-.002.158-.003.244-.003 2.693 0 5.131 1.09 6.898 2.853 1.793 1.739 2.906 4.171 2.906 6.863 0 .098-.001.196-.004.293v-.014c.003.085.004.186.004.287 0 2.706-1.112 5.151-2.904 6.905l-.002.002c-1.777 1.732-4.207 2.801-6.888 2.801-.089 0-.178-.001-.267-.004h.013c-.068.002-.149.003-.229.003-5.374 0-9.731-4.357-9.731-9.731 0-.093.001-.185.004-.277v.014c-.003-.085-.004-.185-.004-.286 0-2.685 1.102-5.112 2.878-6.854l.002-.002zm2.937 11.511c.985 1.075 2.395 1.746 3.962 1.746.104 0 .207-.003.309-.009l-.014.001c.086.005.186.008.287.008 1.545 0 2.933-.672 3.888-1.74l.004-.005c.978-1.11 1.575-2.577 1.575-4.183 0-.057-.001-.113-.002-.17v.008c.001-.047.002-.102.002-.157 0-1.616-.618-3.088-1.631-4.192l.004.005c-.981-1.106-2.405-1.8-3.992-1.8-.047 0-.095.001-.142.002h.007c-.079-.004-.172-.007-.266-.007-1.576 0-2.995.67-3.988 1.741l-.003.003c-.983 1.107-1.583 2.573-1.583 4.179 0 .058.001.116.002.173v-.008c-.002.063-.003.137-.003.211 0 1.611.601 3.082 1.591 4.201l-.006-.007zM87.185 19.696L79.366 6.612v13.084h-4.127V.304h4.952l7.819 13.145V.304h4.083v19.392zM110.4 11.677c-3.788-.634-6.082-2.606-6.082-5.812-.002-.051-.003-.111-.003-.172 0-1.68.828-3.167 2.099-4.075l.015-.01c1.331-1.005 3.013-1.609 4.836-1.609.065 0 .13.001.195.002h-.01c.089-.003.194-.005.299-.005 2.826 0 5.374 1.192 7.168 3.101l.005.005-2.763 2.902c-1.225-1.361-2.986-2.22-4.948-2.242h-.004c-1.738 0-2.85.773-2.85 1.911s.869 1.738 2.763 2.042l1.911.313c4.344.686 6.533 2.711 6.533 6.082.001.032.001.071.001.109 0 1.715-.836 3.234-2.124 4.173l-.015.01c-1.421.997-3.187 1.594-5.092 1.594-.165 0-.329-.004-.491-.013l.023.001c-.047.001-.103.001-.159.001-3.166 0-5.998-1.433-7.882-3.686l-.013-.016 2.824-2.85c1.227 1.697 3.201 2.789 5.43 2.789h.055-.003c2.103 0 3.371-.869 3.371-2.103 0-1.025-.912-1.738-2.711-2.042zM129.965.304h15.222v3.788h-5.56v15.639h-4.092V4.092h-5.56zM164.127.304l7.585 19.392h-4.266l-1.503-3.814h-7.498l-1.52 3.814h-4.257L160.201.304zm-1.964 5.587l-2.407 6.342h4.813zM193.814 19.696L190 13.475h-3.293v6.221h-4.127V.304h8.028c.104-.005.225-.007.348-.007 1.877 0 3.604.637 4.979 1.707l-.018-.014c1.29 1.044 2.108 2.627 2.108 4.401 0 .087-.002.174-.006.26v-.012c.001.035.001.077.001.118 0 2.629-1.544 4.897-3.775 5.946l-.04.017 4.283 6.994zm-7.107-15.639v5.621h3.18c2.685 0 4.04-.947 4.04-2.85s-1.277-2.772-4.04-2.772z"
                    />
                  </svg>
                </div>
              </a>

              <div className="row">
                {Array.isArray(footer.links) &&
                  footer.links.map(({ externalRef, internalRef, label }) => (
                    <div key={label}>
                      {externalRef && (
                        <a
                          href={externalRef}
                          aria-label={label}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          {label}
                        </a>
                      )}
                      {internalRef && (
                        <Link aria-label={label} to={internalRef}>
                          {label}
                        </Link>
                      )}
                    </div>
                  ))}

                <div className="contact">
                  <div className="left">
                    {footer.addressBlock && (
                      <div
                        className="address"
                        dangerouslySetInnerHTML={{
                          __html: footer.addressBlock
                        }}
                      />
                    )}
                  </div>
                  <div className="right">
                    {footer.phone && (
                      <a href={`tel:${footer.phone}`}>Phone: {footer.phone}</a>
                    )}
                    {footer.email && (
                      <a href={`mailto:${footer.email}`}>
                        Email: {footer.email}
                      </a>
                    )}
                    {Array.isArray(footer.policy) && (
                      <div className="policy-links">
                        {footer.policy.map(
                          ({ name, externalRef, internalRef }) => {
                            if (internalRef) {
                              return (
                                <Link key={name} to={internalRef}>
                                  {name}
                                </Link>
                              );
                            }
                            return (
                              <a key={name} href={externalRef}>
                                {name}
                              </a>
                            );
                          }
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="social">
                  {Array.isArray(footer.socials) &&
                    footer.socials.map(({ label, url }) => (
                      <a
                        key={url}
                        aria-label={label}
                        rel="noopener noreferrer"
                        target="_blank"
                        href={url}
                      >
                        {label}
                      </a>
                    ))}
                </div>
                {footer.copyright && (
                  <div className="copyright">{footer.copyright}</div>
                )}
                <div className="powered-by">
                  Built with{" "}
                  <a
                    href="https://github.com/ironstar-io/gatsby-theme-docs-engine"
                    target="_blank"
                  >
                    Bantan Docs Engine
                  </a>{" "}
                  by <a href="https://ironstar.io">Ironstar</a>
                </div>
              </div>
            </div>
          </footer>
        );
      }}
    </SiteContext.Consumer>
  );
};

export default Footer;
